import type { FormContext, StepContext } from '../types'
import { TrackingEvent } from '../types'

export interface FormViewedArgs {
  formContext: FormContext
  stepContext: StepContext
}

export interface FormViewedProperties {
  formContext: FormContext
  stepContext: StepContext
}

export class FormViewed extends TrackingEvent {
  properties: FormViewedProperties

  constructor(args: FormViewedArgs) {
    const {
      formContext = {
        formName: '',
        formType: '',
        formVersion: '',
        formId: '',
      },
      stepContext = {
        stepId: '',
        stepName: '',
        stepNumber: 0,
      },
    } = args ?? {}

    super('FormViewed', 'redventures.usertracking.v3.FormViewed')

    this.properties = {
      formContext: {
        formName: formContext.formName,
        formType: formContext.formType,
        formVersion: formContext.formVersion,
        formId: formContext.formId,
      },
      stepContext: {
        stepId: stepContext.stepId,
        stepName: stepContext.stepName,
        stepNumber: stepContext.stepNumber,
      },
    }
  }
}
